import React from "react";
import OrigPaginate from "react-paginate";

// Unwrap CommonJS/ESM interop if needed
const ResolvedPaginate: any = (OrigPaginate as any)?.default || OrigPaginate;

export const ReactPaginate: React.FC<any> = (props) => {
  const Component = ResolvedPaginate;
  return <Component {...props} />;
};

export default ReactPaginate;
